<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtros
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
        >
          <label>Marca</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="marcaFilter"
              :options="marcaOptions"
              :reduce="val => val.cod_marca"
              class="w-100"
              label="des_marca"
              @input="(val) => $emit('update:marcaFilter', val)"
          >
            <template v-slot:no-options="{ search, searching, loading }">
              Nenhum resultado encontrado
            </template>
          </v-select>
        </b-col>
        <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
        >
          <label>Referência</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="referenciaFilter"
              :options="referenciaOptions"
              class="w-100"
              label="descricao"
              :disabled="marcaFilter === null"
              @input="(val) => $emit('update:referenciaFilter', val)"
          >
            <template v-slot:selected-option="{descricao}">
              <span>{{descricao}}</span>
            </template>

            <template v-slot:no-options="{ search, searching, loading }">
              Nenhum resultado encontrado
            </template>
          </v-select>
        </b-col>
        <b-col
            cols="12"
            class="mb-md-0 mt-2"
        >
          <b-button
              @click="handleApplyFilters"
              variant="primary"
              class="mr-1"
          >
            Pesquisar
          </b-button>
          <b-button
              @click="clearAllFilters"
              variant="danger"
          >
            Limpar
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

export default {
  props: [
    'marcaFilter',
    'referenciaFilter',
    'marcaOptions',
    'referenciaOptions',
  ],
  watch: {
    marcaFilter(newVal) {
      if (!newVal) {
        this.$emit('update:referenciaFilter', null);
      }
    },
  },
  methods: {
    handleApplyFilters() {
      // if (!this.marcaFilter) {
      //   this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //     title: 'Aviso',
      //     text: 'Selecione uma marca!',
      //     icon: 'AlertTriangleIcon',
      //     variant: 'warning',
      //   },
      // })
      //   return;
      // }
      this.$emit('applyFilters');
    },
    clearAllFilters() {
      this.$emit('update:marcaFilter', null);
      this.$emit('update:referenciaFilter', null);

      setTimeout(() => {
        this.$emit('clearFilters');
      }, 100);
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
